import { BaseService } from './base.service';

export interface OpenDoorRequest {
  cloudNodeId?: string;
  deviceId?: string;
  bookingId?: string;
  facilityType?: string;
}

export interface DoorResponse {
  message?: string;
  timestamp: number;
  opened: boolean;
}

export interface FacilityAccessStatus {
  accessControlEnabled: boolean;
  facilityType: string;
}

export class AccessControlService extends BaseService {
  constructor() {
    super('/access-control');
  }

  async openDoor(request: OpenDoorRequest): Promise<DoorResponse> {
    return this.post<DoorResponse>('/open-door', request);
  }

  /**
   * Lazily checked when the open-gate screen loads for a specific booking —
   * never at listing time, so bookings days out don't trigger a BookingType
   * lookup on every dashboard/list load.
   */
  async getFacilityAccessStatus(bookingId: string): Promise<FacilityAccessStatus> {
    return this.get<FacilityAccessStatus>(`/facility-status/${bookingId}`);
  }
}

export const accessControlService = new AccessControlService();
